import { GalleryService } from './../gallery.service';
import { CmsService } from './../cms.service';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SnippetService } from '../snippet.service';

@Component({
    selector: 'app-snippet-add',
    templateUrl: './snippet-add.component.html',
    styleUrls: ['./snippet-add.component.scss']
})
export class SnippetAddComponent implements OnInit {
    @Input() page;
    @Output() modalAction: EventEmitter<any> = new EventEmitter<any>();

    snippet = {
        type: '',
        name: '',
        content: '',
        paddingH: '',
        paddingV: '',
        backgroundColour: '',
        bgImage: '',
        external: 0,
        externalURL: '',
        routeToLink: '',
        colsDesktop: 1,
        gridGutters: 1,
        gridHeight: 200,
        textFontSize: 22,
        showNavButton: false,
        navButtonClass: '',
        linkText: '',
        linkUrl: '',
        linkPageId: 0,
        gallery: '',
    };
    plugins = [];
    pages = [];
    galleries = [];

    types = [
        { id: 'wysiwyg', name: 'Text area' },
        { id: 'grid', name: 'Responsive grid' },
        { id: 'gallery', name: 'Slider gallery' },
        { id: 'image', name: 'Image' },
        { id: 'plugin', name: 'Plugin' },
        { id: 'video', name: 'Video' },
        { id: 'c2a', name: 'Call to action' },
    ];
    cols = [1, 2, 3, 4, 5, 6];
    paddingsH = [
        { id: '', name: 'None' },
        { id: 'px-1', name: 'Padding x 1' },
        { id: 'px-2', name: 'Padding x 2' },
        { id: 'px-3', name: 'Padding x 3' },
        { id: 'px-4', name: 'Padding x 4' },
        { id: 'px-5', name: 'Padding x 5' },
    ];
    paddingsV = [
        { id: '', name: 'None' },
        { id: 'py-1', name: 'Padding x 1' },
        { id: 'py-2', name: 'Padding x 2' },
        { id: 'py-3', name: 'Padding x 3' },
        { id: 'py-4', name: 'Padding x 4' },
        { id: 'py-5', name: 'Padding x 5' },
    ];
    backgroundColours = [
        { id: '', name: 'None' },
        { id: 'bg-grey', name: 'grey' },
        { id: 'bg-white', name: 'White' },
        { id: 'bg-teal', name: 'Teal' },
    ];
    buttonClasses = [
        { id: 'btn-yellow', name: 'Yellow' },
        { id: 'btn-white', name: 'White' },
        { id: 'btn-transparent', name: 'Transparent' },
        { id: 'btn-slate', name: 'Slate' },
        { id: 'btn-blue', name: 'Blue' },
    ]

    tinyInit = {
        height: 500,
        menubar: false,
        toolbar:
            'undo redo | formatselect | bold italic backcolor visualblocks template | \
            alignleft aligncenter alignright alignjustify image | \
            bullist numlist outdent indent | removeformat | help',
        plugins: [
            'advlist autolink lists link image charmap print preview anchor visualblocks',
            'searchreplace visualblocks code fullscreen template image imagetools importcss',
            'insertdatetime media table paste code help wordcount'
        ],
    };

    constructor(
        private snippetService: SnippetService,
        private cmsService: CmsService,
        private galleryService: GalleryService,
    ) { }

    ngOnInit() {
        this.getPlugins();
        this.getPages();
        this.getGalleries();

    }

    toggleValue(v) {
        if (!this.snippet[v]) {
            this.snippet[v] = true;
        } else {
            this.snippet[v] = false;
        }
    }

    getPages() {
        this.cmsService.getAll().subscribe(data => {
            this.pages = data.data;
        })

    }

    getGalleries() {
        this.galleryService.getAll().subscribe(data => {
            this.galleries = data.data;
        })
    }

    save() {
        const dataToEmit = {
            completed: true,
            snippet: this.snippet,
        };
        this.snippetService.createSnippet(this.page, this.snippet).subscribe(data => {
            this.modalAction.emit(dataToEmit);
        });
    }
    cancel() {
        const dataToEmit = {
            completed: false,
        };
        this.modalAction.emit(dataToEmit);
    }

    getPlugins() {
        this.snippetService.getPlugins().subscribe(data => {
            this.plugins = data.data;
        });
    }
}
